export default function SectionLabel({ children }) {
  return (
    <h3 className="text-[11px] font-bold uppercase tracking-[0.12em] text-deep-teal mb-3">
      {children}
    </h3>
  );
}
